import { Controller } from "@hotwired/stimulus"

const TURBO_EVENTS = ["turbo:morph", "turbo:render", "turbo:load"]

export default class extends Controller {
  static targets = ["bar", "spacer", "content"]

  connect() {
    this.syncing = false
    this.onBarScroll = () => this.copyScroll(this.barTarget, this.contentTarget)
    this.onContentScroll = () => this.copyScroll(this.contentTarget, this.barTarget)
    this.barTarget.addEventListener("scroll", this.onBarScroll)
    this.contentTarget.addEventListener("scroll", this.onContentScroll)
    this.resizeObserver = new ResizeObserver(() => this.update())
    this.resizeObserver.observe(this.contentTarget)
    this.onRefresh = () => this.update()
    TURBO_EVENTS.forEach(name => document.addEventListener(name, this.onRefresh))
    this.update()
  }

  disconnect() {
    this.barTarget.removeEventListener("scroll", this.onBarScroll)
    this.contentTarget.removeEventListener("scroll", this.onContentScroll)
    TURBO_EVENTS.forEach(name => document.removeEventListener(name, this.onRefresh))
    this.resizeObserver.disconnect()
  }

  copyScroll(from, to) {
    if (this.syncing) return
    this.syncing = true
    to.scrollLeft = from.scrollLeft
    requestAnimationFrame(() => { this.syncing = false })
  }

  update() {
    const content = this.contentTarget
    this.resizeObserver.disconnect()
    this.resizeObserver.observe(content)
    Array.from(content.children).forEach(child => this.resizeObserver.observe(child))
    this.barTarget.hidden = content.scrollWidth <= content.clientWidth
    this.barTarget.style.width = `${content.clientWidth}px`
    this.spacerTarget.style.width = `${content.scrollWidth}px`
    this.barTarget.scrollLeft = content.scrollLeft
  }
}
